import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import rest from 'rest';
import { Link } from 'react-router-dom';
// import ReactTooltip from 'react-tooltip';
// const UUID = require('uuid/v4');
import moment from 'moment';

import { getDateFromString } from '../../Utils/Date.js';
import { getSubObjectProperty } from '../../Utils/Utils.js';
import { REST_API_URL, APP_PATH, PERMISSION_CREATE } from "../../Utils/Global";

import PermissionCheck from '../Permissions/PermissionCheck';

import Action from './Grid/Action';
import ExportCSV from '../Helper/Grid/ExportCSV';
import Status from './Status';
import ModalMessage from './ModalMessage';

import loader from '../../resources/images/wait.gif';

/**
* Class Grid
* Generic component to generate grids
**/
class Grid extends Component {
  /**
  * props
  * title : title of the grid
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * objectClass : class name of the object's form
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);
    this.state = {isDataFetched:false,objects: [], fields: [], status: {}, modalMessage: {}, hidden: (props.hidden !== undefined) ? props.hidden : true};
    // Bind event functions to keep scope
    this.createActions = this.createActions.bind(this);

    this.dateFields = [];
	}

  /**
  * componentWillMount
  * Pre-rendering component function : loading fields to display
  **/
  componentWillMount() {
    let fieldsUrl = REST_API_URL + this.props.path.replace('contactsEnvironnement','contacts') + '/fields';
    if(this.props.customFieldsUrl !== undefined) {
      fieldsUrl = REST_API_URL + this.props.path.replace('contactsEnvironnement','contacts') + '/' + this.props.customFieldsUrl;
    }

    rest({method: 'GET', path: fieldsUrl, mixin: {withCredentials: true}}).then(response => {
      let state = this.state;
      state.fields = JSON.parse(response.entity);
			this.setState(state);
      this.state.isDataFetched=true
		});
  }

  /**
  * componentDidMount
  * Post-rendering component function : loading data
  **/
	componentDidMount() {
		this.reload();
	}

  /**
  * reload
  * Reloads the data
  **/
  reload() {
    rest({method: 'GET', path: REST_API_URL + this.props.objectPath.replace('contactsEnvironnement','contacts') + '/'}).then(response => {
      let res = JSON.parse(response.entity);

      res = res.map(obj => {
        for(let i=0; i<this.dateFields.length; i++) {
          const fieldName = this.dateFields[i];
          obj[fieldName] =  getDateFromString(obj[fieldName]);
        }

        return obj;
      });

      let state = this.state;
      state.objects = res;
      this.setState(state);
      this.state.isDataFetched=true

      if(this.props.onReload instanceof Function) {
        this.props.onReload.call(this);
      }
		});
  }

  /**
  * componentWillUnmount
  * Post-rendering component function : remove status timeout if exists
  **/
  componentWillUnmount() {
    if(this.status !== undefined) {
        this.status.unsetTimeout();
    }
  }

  /**
  * createActions
  * Creates row actions buttons
  **/
  createActions(cell, row, opt) {
    const props = {
      object: row,
      objectClass: this.props.objectClass,
      parentGrid: this,
      fields: this.state.fields,
      mode: this.props.mode,
      isGeom: this.props.isGeom === true,
      withoutView: this.props.isGeom === true
    };

    const component = <Action {...props}></Action>;
    return component;
  }

  /**
  * dateFormatter
  * Formats date
  **/
  dateFormatter(cell, row, extraParams, withTip) {
    let value = "";
    if(typeof cell === "string") {
      value = cell;
    } else {
      if(!cell || typeof cell.getDate !== "function") return;
      value = `${('0' + cell.getDate()).slice(-2)}/${('0' + (cell.getMonth() + 1)).slice(-2)}/${cell.getFullYear()}`;
    }

    return this.renderCellContent(value, row, extraParams, withTip);
  }

  /**
  * objectFormatter
  * Formats objects
  **/
  objectFormatter(cell, row, extraParams, withTip) {
    let value = null;
    const extraFields = extraParams.fields;

    if(extraFields instanceof Array) {
      let fields = extraFields.map((item) => item);
      let obj = row;

      while(fields.length > 0) {
        if(obj instanceof Object) {
          const currentField = fields.shift();
          value = obj[currentField];
          obj = obj[currentField];
        } else {
          value = null;
          break;
        }
      }
    }

    if(extraParams.type === "Boolean") return this.booleanFormatter(value);
    if(extraParams.type === "Currency") return this.currencyFormatter(value);
    if(extraParams.type === "Date") return this.dateFormatter(value, row, extraParams, withTip);

    return this.renderCellContent(value, row, extraParams, withTip);
  }

  /**
  * currencyFormatter
  * Formats currency numbers
  **/
  currencyFormatter(cell, row, extraParams, withTip) {
    cell = Math.round(cell * 100) / 100;
    const value = cell.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + "€";
    return this.renderCellContent(value, row, extraParams, withTip);
  }

  /**
  * fileFormatter
  * Formats file URL
  **/
  fileFormatter(cell, row, extraParams, withTip) {
    const value = row.cheminStockage ? <a href={REST_API_URL + this.props.path.replace('contactsEnvironnement','contacts') + "/" + cell + "/file"} target="_blank">{row.cheminStockage}</a> : null;
    return this.renderCellContent(value, row, extraParams, withTip);
  }

  /**
  * booleanFormatter
  * Formats booleans
  **/
  booleanFormatter(cell, row, extraParams, withTip) {
    const value = (cell === true) ? "Oui" : "Non";
    return this.renderCellContent(value, row, extraParams, withTip);
  }

  /**
  * renderCellContent
  * Render the cell content
  **/
  renderCellContent(value, row, extraParams, withTip) {
    if(withTip === false) return value;
    return <span title={value}>{value}</span>;
    // ISSUE : slows down table rendering
    // const id = UUID();
    // return (
    //   <div>
    //     <div data-tip data-for={id}>{value}</div>
    //     <ReactTooltip id={id} type="info">{value}</ReactTooltip>
    //   </div>
    // );
  }

  _setTableOption(){

       if(this.state.isDataFetched){
             return "Aucune donnée à afficher";
        }else{
             return(
               <center><img src={loader} className="App-wait" alt="loader" /></center>

             );
        }
  }

  /**
  * render
  * Rendering component function : display the grid
  **/
  render() {
    if(this.state.fields.length === 0) {
        return <div></div>;
    }

    // Concatenate grid headers
    let headers = this.getHeaders();

    if(this.props.withoutActions !== true) {
      headers.push(
        <TableHeaderColumn key="actions" dataField="actions" width="100"
          dataFormat={(this.props.createActionsFunction instanceof Function) ? this.props.createActionsFunction.bind(this) : this.createActions} isKey={false}>
        </TableHeaderColumn>
      );
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    // Modal message
    const modalMessage = <ModalMessage parent={this} {...this.state.modalMessage} />;

    const options = {
      //noDataText: 'Aucune donnée à afficher'
      noDataText: this._setTableOption(),
    };

    // const addButton = (this.props.ignoreAdd === true || this.props.mode === "readonly") ? null : (
    //   <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_CREATE}>
    //     <p className="gridBottomToolbar">
    //       <Link to={APP_PATH + "/" + this.props.objectPath + "/add"}>
    //         <Button bsStyle="success" className="gridAddObjectBtn">Ajouter</Button>
    //       </Link>
    //     </p>
    //   </PermissionCheck>
    // );

    console.log("ssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss");
var addButton = (<p className="gridBottomToolbar"></p>);
    if (this.props.isGeom==undefined && this.props.objectPath!="projets" && this.props.objectPath!="contrats" && this.props.objectPath!="clients" && this.props.path!="contactsEnvironnement" )
    {
      addButton = (
        <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_CREATE}>
          <p className="gridBottomToolbar">
            <Link to={APP_PATH + "/" + this.props.objectPath.replace('contactsEnvironnement','contacts').split("/?interne")[0] + "/add"}>
              <Button bsStyle="success" className="gridAddObjectBtn">Ajouter</Button>
            </Link>
          </p>
        </PermissionCheck>
      );


    }

    let tableProps = {
      ref: "table" + this.props.objectClass.getClassName(),
      data: this.state.objects,
      options: options,
      maxHeight: (this.props.height !== undefined) ? this.props.height : "200px",
      pagination: false,
      striped: true,
      hover: true,
      condensed: true,
      className: this.props.condensed ? "condensedGrid" : ""
    };

    if(this.props.trClassNameFunction instanceof Function) tableProps.trClassName = this.props.trClassNameFunction.bind(this);

    console.log('f');

    const csvExport = (this.props.exportCsv instanceof Object) ?
      <ExportCSV {...this.props.exportCsv}/> : null;

    // Creating Grid
    const table =
      <div className="listContainer" id={this.props.objectClass.getClassName() + "Grid"}>
        {modalMessage}
        {this.props.title &&
          <h4 className="gridTitle" onClick={this.props.hiddable === true ? this.showGrid.bind(this) : null}>
            {this.props.title}
            {this.props.hiddable === true ? <span className={"glyphicon glyphicon-chevron-" + (this.state.hidden === false ? "down" : "right")}></span> : null}
          </h4>
        }

        {this.state.hidden === false &&
          <div>
            {this.props.filters}
            <div className={"grid " + this.props.objectClass.getClassName() + "Grid"}>
              {addButton}
              {status}
              <BootstrapTable {...tableProps}>
                {headers}
              </BootstrapTable>
            </div>
            {csvExport}
          </div>
        }

      </div>;

    return table;
  }

  /**
  * showGrid
  * Manage grid visilibity
  **/
  showGrid() {
    let state = this.state;
    state.hidden = !state.hidden;
    this.setState(state);
    this.state.isDataFetched=true
  }

  /**
  * getFieldsKey
  * Returns the ID field (property isKey)
  **/
  getFieldsKey() {
    for(let i=0; i<this.state.fields.length; i++) {
      const field = this.state.fields[i];

      if(field.isKey) {
        return field;
      }
    }

    return null;
  }

  /**
  * getRowKey
  * Returns the ID field's name
  **/
  getRowKey() {
    const fieldsKey = this.getFieldsKey();
    let value = null;

    if(fieldsKey) {
      value = fieldsKey.nom;
    }

    return value;
  }

  /**
  * deleteRow
  * Delete an object
  **/
  deleteRow(object) {
    const thisRef = this;

    const fn = function(ok) {
      if(ok) {
        const idKey = thisRef.getRowKey();
        const id = object[idKey];

        if(id === undefined || id === null) {
          thisRef.setState({
            modalMessage: {},
            status: {
              type: 'danger',
              message: 'Erreur : identifiant ' + thisRef.props.objectClass + ' non défini'
            }
          });

          return;
        }

        const path = REST_API_URL + ((this.props.isGeom === true) ? thisRef.props.path.replace('contactsEnvironnement','contacts') + "/" + object["tableRefName"] + "/" + id : thisRef.props.path + "/" + id);

        rest({
          method: "DELETE",
          path: path,
        }).then(response => {
          if(response.status.code === 202) {
            thisRef.setState({
              modalMessage: {},
              status: {
                type: 'success',
                message: 'Ligne supprimée.'
              }
            });

            thisRef.componentDidMount();
          } else {
            thisRef.setState({
              modalMessage: {},
              status: {
                type: 'danger',
                message: 'Erreur de sauvegarde.'
              }
            });
          }
      	}, response => {
          thisRef.setState({
            modalMessage: {},
            status: {
              type: 'danger',
              message: 'Problème d\'appel au serveur.'
            }
          });
    		});
      } else {
        thisRef.setState({
          modalMessage: {}
        });
      }
    };

    let state = this.state;
    state.modalMessage = {
      parent : this,
      style : "warning",
      title : "Supprimer la ligne",
      message : <div><p>Cette action va supprimer la ligne et toutes les relations la concernant.</p><p><b>Continuer ?</b></p></div>,
      onlyOk : false,
      handleOk : fn,
      handleCancel : fn,
      visible : true
    };

    this.setState(state);
    this.state.isDataFetched=true

  }

  /**
  * applyFilter
  * Filters the table
  **/
  applyFilter(fieldName, value) {
    const field = this.refs["table" + this.props.objectClass.getClassName() + fieldName];
    (value instanceof Array) ? field.handleFilter(value, "ArrayFilter") : field.applyFilter(value);
  }

  applyNumFilter(fieldName, values) {
    const field = this.refs["table" + this.props.objectClass.getClassName() + fieldName];

    //const regex = new RegExp('[' + value   + '-' +value + ']');
    //console.log(regex);
    //field.handleFilter( regex, "RegexFilter");

    values.valueSup=values.valueInf;

    field.handleFilter({ callback: this.isNumericFiltered, currentValues: values });

  }
  /**
  * applyNumericFilter
  * Filters the table
  **/
  applyNumericFilter(fieldName, values) {
    const numericFilter = this.numberFilters[fieldName];

    if(numericFilter) {
      if(!values.valueInf && !values.valueSup) {
        numericFilter.filterHandler();
      } else {
        numericFilter.filterHandler({ callback: this.isNumericFiltered, currentValues: values });
      }
    }
  }

  /**
  * isNumericFiltered
  * Filters the table
  **/
  isNumericFiltered(value) {
    return (!this.currentValues.valueInf || value >= this.currentValues.valueInf)
        && (!this.currentValues.valueSup || value <= this.currentValues.valueSup);
  }

  /**
  * applyDateIntervalFilter
  * Filters the table
  **/
  applyDateIntervalFilter(fieldName, values) {
    const dateFilter = this.dateFilters[fieldName];

    if(dateFilter) {
      if(!values.startDate && !values.endDate) {
        dateFilter.filterHandler();
      } else {
        dateFilter.filterHandler({ callback: this.isDateFiltered, currentValues: values, fieldName: fieldName });
      }
    }
  }

  /**
  * isDateFiltered
  * Filters the table
  **/
  isDateFiltered(value) {
    if(!value) return false;

    if(value instanceof Object) {
      const arr = this.fieldName.split(".");
      arr.shift();
      value = getSubObjectProperty(arr, value);
    }

    if(typeof value === "string")
      value = moment(value, "DD/MM/YYYY");

    else
      value = moment(value);

    return value && (!this.currentValues.startDate || !(value < this.currentValues.startDate))
        && (!this.currentValues.endDate || !(value > this.currentValues.endDate));
  }

  /**
  * applyDateFilter
  * Filters the table
  **/
  applyDateFilter(dateFieldName, dateValue, comparatorValue) {
    const field = this.refs[dateFieldName];

    if(dateValue) {
      field.applyFilter({
        date: getDateFromString(dateValue),
        comparator: comparatorValue
      });
    } else {
      field.cleanFiltered();
    }
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    for(let key in this.refs) {
      if(this.refs.hasOwnProperty(key) && typeof this.refs[key].cleanFiltered === "function") {
        const filter = this.refs[key].props.filter;

        if(filter !== undefined && (filter.type === "ArrayFilter" || filter.type === "CustomFilter")) {
          this.refs[key].handleFilter();
        } else {
          this.refs[key].cleanFiltered();
        }
      }
    }
  }

  /**
  * getArrayFilterElement
  * Get custom filter element (for array values filtered by cbx)
  **/
  getArrayFilterElement(filterHandler, customFilterParameters) {
    if(this.arrayFilters === undefined) {
      this.arrayFilters = [];
    }

    if(this.arrayFilters[customFilterParameters.fieldName] === undefined) {
      this.arrayFilters[customFilterParameters.fieldName] = customFilterParameters;
      this.arrayFilters[customFilterParameters.fieldName].filterHandler = filterHandler;
    }

    return <div/>;
  }

  /**
  * getNumberFilterElement
  * Get custom filter element (for number values filtered by min/max)
  **/
  getNumberFilterElement(filterHandler, customFilterParameters) {
    if(this.numberFilters === undefined) {
      this.numberFilters = [];
    }

    if(this.numberFilters[customFilterParameters.fieldName] === undefined) {
      this.numberFilters[customFilterParameters.fieldName] = customFilterParameters;
      this.numberFilters[customFilterParameters.fieldName].filterHandler = filterHandler;
    }

    return <div/>;
  }

  /**
  * getDateFilterElement
  * Get custom filter element (for date values filtered by min/max)
  **/
  getDateFilterElement(filterHandler, customFilterParameters) {
    if(this.dateFilters === undefined) {
      this.dateFilters = [];
    }

    if(this.dateFilters[customFilterParameters.fieldName] === undefined) {
      this.dateFilters[customFilterParameters.fieldName] = customFilterParameters;
      this.dateFilters[customFilterParameters.fieldName].filterHandler = filterHandler;
    }

    return <div/>;
  }

  /**
  * NumericFilter
  * Filters the table
  **/
  applyArrayFilter(fieldName, value) {
    if(this.arrayFilters === undefined) return;

    const arrayFilter = this.arrayFilters[fieldName];

    if(arrayFilter) {
      if(value === undefined) {
        arrayFilter.filterHandler();
      } else {
        arrayFilter.filterHandler({ callback: this.isArrayFiltered, currentValue: value, fieldName: fieldName });
      }
    }
  }

  /**
  * isArrayFiltered
  * Filters the table
  **/
  isArrayFiltered(value) {
    if(value instanceof Object) {
      const arr = this.fieldName.split(".");
      arr.shift();
      value = getSubObjectProperty(arr, value);
    }

    if(Array.isArray(this.currentValue)) {

      for(let i=0; i<this.currentValue.length; i++) {
        const id = this.currentValue[i];
        if(value.includes(parseInt(id, 10))) return true;
      }

      return false;
    } else {
      return Array.isArray(value) && value.includes(parseInt(this.currentValue, 10));
    }
  }

  /**
  * getObjectFilterElement
  * Get custom filter element (for object values filtered by cbx)
  **/
  getObjectFilterElement(filterHandler, customFilterParameters) {
    if(this.objectFilters === undefined) {
      this.objectFilters = [];
    }

    if(this.objectFilters[customFilterParameters.fieldName] === undefined) {
      this.objectFilters[customFilterParameters.fieldName] = customFilterParameters;
      this.objectFilters[customFilterParameters.fieldName].filterHandler = filterHandler;
    }

    return <div/>;
  }

  /**
  * applyObjectFilter
  * Filters the table
  **/
  applyObjectFilter(fieldName, value, valueField) {
    console.log('I was triggered during render');
    if(this.objectFilters === undefined) return;

    const objectFilter = this.objectFilters[fieldName];

    if(objectFilter) {
      if(value === undefined) {
        objectFilter.filterHandler();
      } else {
        objectFilter.filterHandler({ callback: this.isObjectFiltered, currentValue: value, idField: valueField });
        console.log("React version:", React.version);
      }
    }
  }

  /**
  * isObjectFiltered
  * Filters the table
  **/
  isObjectFiltered(value) {
    var test=value instanceof Object && value[this.idField].toString() === this.currentValue;
    return value instanceof Object && value[this.idField].toString() === this.currentValue;
  }

  /**
  * getHeaders
  * Return formatted and configured TableHeaderColumn[]
  **/
  getHeaders() {
    return this.state.fields.map(field => {
      let dataField = field.nom;
      let extraFields = null;
      let sortield=true;
      if(dataField.indexOf(".") !== -1) {
        const arr = dataField.split(".");
        sortield=true;
        //dataField = arr.shift();
        extraFields = arr;
      }

      let props = {
        key: field.nom,
        dataField: dataField,
        isKey: field.isKey,
        ref: "table" + this.props.objectClass.getClassName() + field.nom,
        dataSort:sortield,
        tdStyle: { verticalAlign: "middle" }
      };

      if(field.isKey || field.nom === "numero") props.width = "50px";

      if(field.filterType !== undefined) {
        props.filter = {
          type: field.filterType
        };

        switch (field.filterType) {
          // case "DateFilter":
          //   props.dataFormat = this.dateFormatter.bind(this);
          //   this.dateFields.push(field.nom);
          //   break;

          case "DateFilter":
            props.dataFormat = this.dateFormatter.bind(this);
            props.filter.type = "CustomFilter";
            props.filter.getElement = this.getDateFilterElement.bind(this);
            props.filter.customFilterParameters = {fieldName: props.key, fieldRed: props.ref};
            this.dateFields.push(field.nom);
            break;

          case "TextFilter":
            if(field.conditionType) props.filter.condition = field.conditionType;
            break;

          case "CurrencyFilter":
            props.dataFormat = this.currencyFormatter.bind(this);
            props.filter.type = "CustomFilter";
            props.filter.getElement = this.getNumberFilterElement.bind(this);
            props.filter.customFilterParameters = {fieldName: props.key, fieldRed: props.ref};
            break;

          case "FileFilter":
            props.dataFormat = this.fileFormatter.bind(this);
            props.filter.type = "TextFilter";
            break;

          case "ArrayFilter":
            props.filter.type = "CustomFilter";
            props.filter.getElement = this.getArrayFilterElement.bind(this);
            props.filter.customFilterParameters = {fieldName: props.key, fieldRed: props.ref};
            break;

          case "ObjectFilter":
            props.filter.type = "CustomFilter";
            props.dataFormat = this.objectFormatter.bind(this);
            props.formatExtraData = {fields : extraFields};
            props.filter.getElement = this.getObjectFilterElement.bind(this);
            props.filter.customFilterParameters = {fieldName: props.key, fieldRed: props.ref};
            props.sortFunc = this.sortObject.bind(this);
            props.sortFuncExtraData =  {fields : extraFields};
            break;

          case "ObjectBooleanFilter":
            props.filter.type = "CustomFilter";
            props.dataFormat = this.objectFormatter.bind(this);
            props.formatExtraData = {fields : extraFields, type: "Boolean"};
            props.filter.getElement = this.getObjectFilterElement.bind(this);
            props.filter.customFilterParameters = {fieldName: props.key, fieldRed: props.ref};
            props.sortFunc = this.sortObject.bind(this);
            props.sortFuncExtraData = {fields : extraFields, type: "Boolean"};
            break;

          case "ObjectCurrencyFilter":
            props.filter.type = "CustomFilter";
            props.dataFormat = this.objectFormatter.bind(this);
            props.formatExtraData = {fields : extraFields, type: "Currency"};
            props.filter.getElement = this.getObjectFilterElement.bind(this);
            props.filter.customFilterParameters = {fieldName: props.key, fieldRed: props.ref};
            props.sortFunc = this.sortObject.bind(this);
            props.sortFuncExtraData = {fields : extraFields, type: "Currency"};
            break;

          case "ObjectArrayFilter":
            props.filter.type = "CustomFilter";
            props.dataFormat = this.objectFormatter.bind(this);
            props.formatExtraData = {fields : extraFields, type: "Array"};
            props.filter.getElement = this.getArrayFilterElement.bind(this);
            props.filter.customFilterParameters = {fieldName: props.key, fieldRed: props.ref};
            props.sortFunc = this.sortObject.bind(this);
            props.sortFuncExtraData = {fields : extraFields, type: "Array"};
            this.dateFields.push(field.nom);
            break;

          case "ObjectDateFilter":
            props.filter.type = "CustomFilter";
            props.dataFormat = this.objectFormatter.bind(this);
            props.formatExtraData = {fields : extraFields, type: "Date"};
            props.filter.getElement = this.getDateFilterElement.bind(this);
            props.filter.customFilterParameters = {fieldName: props.key, fieldRed: props.ref};
            props.sortFunc = this.sortObject.bind(this);
            props.sortFuncExtraData = {fields : extraFields, type: "Date"};
            this.dateFields.push(field.nom);
            break;

          case "BooleanFilter":
            props.filter.type = "TextFilter";
            props.dataFormat = this.booleanFormatter.bind(this);
            break;

          default:
            break;
        }

        if(field.hidden) {
          props.hidden = true;
        }

        if(!(props.dataFormat instanceof Function)) {
          props.dataFormat = this.renderCellContent.bind(this);
        }

      }

      return <TableHeaderColumn {...props}>{field.libelle}</TableHeaderColumn>;
    });
  }

  /**
  * sortObject
  * Function to sort Object values
  **/
  sortObject(a, b, order, sortField, extraData) {
    let aValue = this.objectFormatter(a[sortField], a, extraData, false);
    let bValue = this.objectFormatter(b[sortField], b, extraData, false);

    try
    {
      aValue = aValue ? aValue.trim().toLowerCase() : "";
      bValue = bValue ? bValue.trim().toLowerCase() : "";
    }
    catch(error)
    {
      try
      {
        aValue = aValue ? aValue.props.title.trim().toLowerCase() : "";
        bValue = bValue ? bValue.props.title.trim().toLowerCase() : "";
      }
      catch(error)
      {

      }

    }

    if(extraData.type === "Date") {
      aValue = getDateFromString(aValue);
      bValue = getDateFromString(bValue);
    }

    if(order === 'asc')
      return aValue === bValue ? 0 : (aValue > bValue ? 1 : -1);

    else
      return aValue === bValue ? 0 : (aValue < bValue ? 1 : -1);
  }

}

export default Grid;



// WEBPACK FOOTER //
// ./src/views/Helper/Grid.js